import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SHOWS, MOVIE_POSTERS } from '../data/mockData';
export function ShowSchedule() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});
  const getPosterUrl = (show: (typeof SHOWS)[0]) => {
    // Use the show's own posterImage first, then fall back to MOVIE_POSTERS lookup
    if (show.posterImage) return show.posterImage;
    return MOVIE_POSTERS[show.title] || '';
  };
  return <div className="mb-8" data-id="element-149">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 px-1" data-id="element-150">
        Today's Schedule
      </h2>
      <div className="flex overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0 gap-4 snap-x hide-scrollbar" data-id="element-151">
        {SHOWS.map((show, index) => {
        const posterUrl = getPosterUrl(show);
        return <motion.div key={show.id} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + index * 0.05
        }} className="flex-none w-[280px] bg-white rounded-xl soft-shadow p-3 flex gap-4 snap-start border border-gray-100" data-id="element-152">
              {/* Movie Poster */}
              <div className="w-16 h-24 rounded-lg flex-shrink-0 overflow-hidden relative" data-id="element-153">
                {posterUrl && !imgErrors[show.id] ? <img src={posterUrl} alt={`${show.title} poster`} className="w-full h-full object-cover" onError={() => setImgErrors(prev => ({
              ...prev,
              [show.id]: true
            }))} data-id="element-154" /> : <div className={`w-full h-full bg-gradient-to-br ${show.posterColor} shadow-inner flex items-center justify-center`} data-id="element-155">
                    <span className="text-white/80 text-[8px] font-bold text-center leading-tight px-1" data-id="element-156">
                      {show.title}
                    </span>
                  </div>}
              </div>

              <div className="flex flex-col justify-center py-1" data-id="element-157">
                <h3 className="font-bold text-gray-900 leading-tight mb-1" data-id="element-158">
                  {show.title}
                </h3>
                <p className="text-sm text-gray-500 mb-2" data-id="element-159">
                  {show.screen} • {show.time}
                </p>
                <div className="flex items-center gap-2" data-id="element-160">
                  <span className={`w-2 h-2 rounded-full ${show.color}`} data-id="element-161" />
                  <span className="text-xs font-medium text-gray-700" data-id="element-162">
                    {show.occupancy}% Full
                  </span>
                </div>
              </div>
            </motion.div>;
      })}
      </div>
    </div>;
}